export default function Heading(props) {
  return <div>{props.message}</div>;
}
